import { Entity, IEntity } from "./Entity";
import { IPPObjective } from "./PPObjective";
import { IPPVision } from "./PPVision";

export interface IPPVisionObjective extends IEntity {
    VisionID?: number;
    ObjectiveID?: number;
    Objective?: IPPObjective;
    Vision?: IPPVision;
}

export class PPVisionObjective extends Entity implements IPPVisionObjective {
    public VisionID = null;
    public ObjectiveID = null;
}